import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import Avatar from '../../Avatar';
import ShareModalLinkCopy from '../../Share/ModalLinkCopy';

import { getFormattedDateTime } from '../../../helpers/DateTime';

const AdminUploadPagesListItem = ({
  history,
  uploadPage,
  openUploadPageEditModal,
  handleDeleteUploadPage,
}) => {
  const intl = useIntl();

  const uploadPageUser = uploadPage.user || uploadPage.created_by;

  return (
    <tr>
      <th scope="row" className="upload-page-title">
        {uploadPage.title}
      </th>
      <td className="upload-page-collection">
        {uploadPage.collection && (
          <a href={`/collections/${uploadPage.collection.uuid}`} target="_blank" rel="noopener noreferrer">
            {uploadPage.collection.name}
          </a>
        )}
      </td>
      <td className="upload-page-files-public">
        {uploadPage.default_files_access === 'inherit' && (intl.formatMessage({ defaultMessage: 'Inherit from collection' }))}
        {uploadPage.default_files_access === 'open' && (intl.formatMessage({ defaultMessage: 'Open' }))}
        {uploadPage.default_files_access === 'restricted' && (intl.formatMessage({ defaultMessage: 'Restricted' }))}
      </td>
      <td className="upload-page-user">
        {uploadPageUser && (
          <a href={`/admin/users/${uploadPageUser.uuid}/edit`} target="_blank" rel="noopener noreferrer">
            <Avatar user={uploadPageUser} />
            {uploadPageUser.name}
          </a>
        )}
      </td>
      <td className="upload-page-created-at">
        {getFormattedDateTime(uploadPage.created_at)}
      </td>
      <td className="action-more">
        <UncontrolledDropdown>
          <DropdownToggle nav className="options">
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-action-more" right container=".main-container">
            <DropdownItem onClick={() => { history.push(`/admin/upload-pages/${uploadPage.uuid}`); }}>
              <i className="fas fa-file-circle-info" />
              {intl.formatMessage({ defaultMessage: 'Details' })}
            </DropdownItem>
            <DropdownItem onClick={() => { openUploadPageEditModal(uploadPage); }}>
              <i className="fas fa-pencil" />
              {intl.formatMessage({ defaultMessage: 'Edit' })}
            </DropdownItem>
            <DropdownItem className="copy-link-dropdown-item">
              <ShareModalLinkCopy
                linkUrl={uploadPage.url.full}
                text={intl.formatMessage({ defaultMessage: 'Copy link' })}
                showTooltip={false}
              />
            </DropdownItem>
            <DropdownItem
              onClick={() => {
                window.open(uploadPage.url.full);
              }}
            >
              <i className="fas fa-file" />
              {intl.formatMessage({ defaultMessage: 'View' })}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={() => { handleDeleteUploadPage(uploadPage.uuid); }}>
              <i className="fas fa-trash" />
              {intl.formatMessage({ defaultMessage: 'Delete' })}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>
  );
};

AdminUploadPagesListItem.propTypes = {
  history: PropTypes.object.isRequired,
  uploadPage: PropTypes.object.isRequired,
  openUploadPageEditModal: PropTypes.func.isRequired,
  handleDeleteUploadPage: PropTypes.func.isRequired,
};

export default withRouter(AdminUploadPagesListItem);
